<template>
  <!-- 内容 -->
  <div class="g-main">
    <!-- tab -->
    <div class="tab-con">
      <router-link :to="'/' + '?hideNav=1'">
        <span href="javascript:;" data-track="djk_kwys_wdfw_tab_tw_click">提问</span>
      </router-link>
      <router-link :to="'/lists/' + '?hideNav=1'">
        <span class="on" href="javascript:;">服务历史</span>
      </router-link>
    </div>

    <template v-if="!noData">
      <div id="scrollview" class="page-services page-scrollview">
        <InfiniteScroll :onInfinite="loadList">
          <div slot="list" class="list">
            <Question v-for="(item, index) in questionLists" :item="item" :index="index" :status="item.status" :key="item.id" @click.native="getPay(item, $event)" data-track="djk_kwys_wdfw_question_click"></Question>
          </div>
          <!-- 数据全部加载完毕显示 -->
          <span slot="doneTip">没有数据啦~~</span>

          <!-- 加载中提示 -->
          <img slot="loadingTip" src="../assets/loading.svg"/>
        </InfiniteScroll>
      </div>

      <!-- 底部 -->
      <div class="bottom-bar border5">
        <Btn size="large" type="primary" track="yy_djk_kwys_jxtw" @click.native="goQuestion">{{btnText}}</Btn>
      </div>

      <!-- 支付弹层 -->
      <div class="popup popup-pay" v-if="!supportShubi">
        <Popup v-model="isPay" position="bottom" width="100%" height="auto">
          <h3>支付方式</h3>
          <div class="con">
            <ul>
              <li class="border4" v-for="(item, index) in payList" :key="index">
                <i class="icon" :class="'icon-' + item.payWayType"></i>
                <span>{{ item.name }}</span>
                <a @click="select(item.id)" href="javascript:;" class="btn-select" :class="item.id === paywayid ? 'on' : ''"></a>
              </li>
            </ul>
            <Btn type="primary" size="large" @click.native="pay">确认支付</Btn>
          </div>
          <a href="javascript:;" class="btn-close border-blue" @click="isPay = false" data-track="djk_kwys_ym_wdfw_zfgb">X</a>
        </Popup>
      </div>
      <payComp :oldPrice="price" :orderCode="orderCode" @paySuccess="paySuccess" ref="payComp" v-else />
    </template>

    <!-- 没有数据的情况 -->
    <div class="no-data" v-else>
      <img src="./../assets/images/no-data.png"/>
      <p>暂无服务</p>
      <div>购买过的服务将显示在这里</div>
      <Btn type="primary" size="large" @click.native="goQuestion"><span>立即提问</span></Btn>
    </div>

    <!-- 用户协议 -->
    <div class="popup popup-protocol">
      <Popup v-model="isProtocol" position="bottom" width="100%" height="100%">
        <h3>用户协议</h3>
        <div class="con">
          <div>
            <p>“快问医生”使用规则</p>
            <p>“快问医生”为您和医生之间的付费健康咨询平台。在您向医生支付咨询费用前，请详细阅读本使用规则。</p>
            <h4>一、服务</h4>
            <p>1、本服务所称“咨询”特指您通过“快问医生”提交问题并支付费用后，“快问医生”将您提交的问题随机分配给“快问医生”合作方的医生（ 以下简称“医生”），由医生认领问题并进行回复。</p>
            <p>2、在您提交问题时以及与医生对话过程中，请您不要披露您的真实个人信息，如您仍披露的，视为您同意披露；并且您提交问题时发布的文字或图片，系统指定医生可查看，如您不同意的，请您立即停止提交问题。</p>
            <p>3、每一问题，您发言后医生进行回复计为一次对话，您可在提交问题后【24】小时内与医生进行20次对话。请您特别注意，您提交的问题将在您提问已满【24】小时后（自您提交问题之时起算【24】小时）或您与医生已进行20次对话后关闭。</p>
            <p>4、如对话过程中，您偏离问题或者发言不符合言行要求，医生有权提醒您改正（此种情形下，医生的提醒视为医生回复），如您不改正的，医生有权【拒绝回复直至问题关闭】。</p>
            <p>5、您提交问题并支付费用，视为您向医生发出了不可撤销的合同要约，医生第一次回复时，方视为医生与您之间建立了合同关系；您了解并知悉，医生有完全的、自主的权利决定是否就您的问题进行第一次答复，如您提交问题后，超过1小时没有医生第一次回复，“快问医生”将在1-3个工作日内向您原路退还您已经支付的费用。</p>
            <p>6、建议您根据实际情况描述问题，并辅助图片说明，这样将提高您的问题获得医生第一次回复的机会。</p>
            <p>7、您了解医生仅能尽可能利用专业知识及临床经验给予您一定的解惑及帮助建议，不进行诊断或治疗，同时不对答复是否符合您的预期做保证。除另有明确说明外，您不得因为咨询服务中的内容不满意要求退款。</p>
            <h4>二、费用</h4>
            <p>1、每次咨询将收取您一定的费用，请您在付费前注意查看费用金额、使用提示等并审慎选择。</p>
            <p>2、您不可撤销地授权宝宝树代为收取您支付给医生的咨询费用，宝宝树将在咨询结束后按照与合作方的相关协议向合作方或医生支付费用。</p>
            <p>3、您了解并知悉，除另有明确说明外，任何情况下您均不得要求退款。</p>
            <h4>三、权利义务</h4>
            <p>1、如您对咨询不满意的，可向宝宝树提出投诉。</p>
            <p>2、如您与医生发生服务纠纷的，您可通过司法部门或行政部门依照法定程序要求宝宝树提供相关数据，宝宝树应积极配合并提供有关资料。</p>
            <p>3、在咨询过程中您发布的内容或提问必须遵守中国法律法规、行政规章以及规范性文件、遵守宝宝树公布的所有服务协议，并不得有以下行为：</p>
            <p>（1）发布以下内容：煽动抗拒、破坏宪法及法律法规实施的言论；煽动颠覆国家政权、破坏国家统一的言论；违背社会风俗和社会道德的言论；煽动民族仇恨、民族歧视，破坏民族团结的言论； </p>
            <p>（2）发布使用任何侮辱或毁谤他人，性骚扰，或对未成年人有不良影响的内容；</p>
            <p>（3）发布淫秽、色情、赌博、暴力、凶杀、恐怖、非法宗教或者教唆犯罪的内容； </p>
            <p>（4）发布广告等牟利性经营活动的内容；</p>
            <p>（5）发布侵犯第三方权利，特别是他人著作权、商标权等知识产权或者合法权利的内容；</p>
            <p>（6）发布要求医生进行诊断或治疗的内容；</p>
            <p>（7）其他根据宝宝树平台性质，不适宜发布的内容。</p>
            <p> 如您违反的，宝宝树有权视情况选择以下一种或几种措施：</p>
            <p>（1）立即对相应信息进行删除、屏蔽；</p>
            <p>（2）中止向您提供部分或全部服务；</p>
            <p>（3）查封您的账户，终止向您提供服务；</p>
            <p>（4）要求您赔偿损失（包括宝宝树自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿宝宝树的上述全部损失。</p>
            <p>3、您在咨询过程中应语言文明，尊重医生，平等交流。如有对医生恶意中伤，语言不文明，医生有权【拒绝回复直至问题关闭】，您无权要求退款。</p>
            <h4>四、免责</h4>
            <p>1、咨询中医生所提供内容均是个人建议，不得做为诊断、治疗的直接医疗处置依据，用户需知晓并同意诊断及治疗均需前往医院。擅自将医生建议做为处方使用的，后果自负。是否采信咨询中医生的意见为您的个人行为，“快问医生”及宝宝树不承担任何可能产生的责任。</p>
            <p>2、“快问医生”有权对您的注册数据及咨询的行为进行查阅，发现注册数据或咨询行为中存在任何问题或合理怀疑，均有权向您发出询问及要求改正的通知或者直接作出删除等处理。</p>
            <p>3、对于您在使用“快问医生”中的不当行为或其它任何“快问医生”认为应当终止服务的情况，“快问医生”有权随时作出删除相关信息、终止服务提供等处理，而无须征得您的同意。</p>
          </div>
        </div>
        <a href="javascript:;" class="btn-close border-blue" @click="closeProtocol">X</a>
      </Popup>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Cookies from 'js-cookie';
  import {mapState} from 'vuex';
  import Question from '../components/Question';
  import Btn from '../components/Btn';
  import Popup from '../components/Popup';
  import payComp from '../components/payComp';
  import InfiniteScroll from '../components/InfiniteScroll';
  import {preventShowBoundary} from '../assets/utils';
  import {submitForm} from './../stores/actions';
  import doLogin from '../lib/do-login';

  export default {
    name: 'service',
    data() {
      return {
        listScroll: {
          isLoading: false,
          scrollId: null,
          lastScrollHeight: ''
        },
        isLogin: false,
        noData: false,
        payList: {},
        isPay: false,
        payData: {},
        price: null,
        paywayid: 4,
        orderCode: 0,
        interrogationId: null,
        questionLists: [],
        currentPage: 1,
        size: 20
      };
    },
    components: {Question, Btn, Popup, InfiniteScroll, payComp},
    computed: {
      ...mapState(['navBar', 'lists', 'question', 'isProtocol']),
      btnText() {
        return window.token ? '继续提问' : '立即登录';
      },
      supportShubi() {
        const curserVersion = doLogin.getAppVersion();
        return window.isApp === 1 && curserVersion > 239;
      }
    },
    beforeCreate() {
      // 更新顶部状态
      this.$store.dispatch('updateNav', {
        title: '快问医生',
        type: 'center'
      });
      // 复制给全局 window
      window.VM = this;
    },

    created() {
      // 发埋点
      if (window.Tracking && typeof window.Tracking.initTrackUrl === 'function') {
        window.Tracking.initTrackUrl(2, 'djk_kwys_ym_wdfw', '');
      }

      // 第一次 获取问题列表
      this.$store.dispatch('getQuestionList', {
        data: {
          pagesize: this.size,
          curpage: this.currentPage
        },
        isUpdate: false
      }).then((v) => {
        if (v.err) {
          if (v.err === '无问诊信息') {
            this.noData = true;
            return false;
          } else if (v.err === '用户过期，请重新登录') {
            this.isLogin = false;
          } else {
            this.$dialog.Toast({mes: v.err});
          }
          return false;
        }

        this.$store.dispatch('setNoQuestion', false);
        this.questionLists.push(...v.data);
        return true;
      });

      // 获取支付列表
      this.$store.dispatch('getPay', {
        type: 3
      }).then((v) => {
        if (v.err && v.err !== '用户过期，请重新登录') {
          this.$dialog.Toast({mes: v.err});
          return false;
        }

        if (!Cookies.get('MT_USER_INFO')) {
          const ua = navigator.userAgent.toLowerCase();
          if (ua.indexOf('micromessenger') !== -1) {
            // 微信环境，只能选择微信支付
            v.data.payWayList.forEach((payway) => {
              if (payway.id === 4) {
                this.payList = [payway];
              }
            });
            // this.payList = v.data.payWayList.slice(1);
          } else {
            // 非微信环境，只能选择支付宝支付
            v.data.payWayList.forEach((payway) => {
              console.log(payway);
              if (payway.id === 1) {
                this.payList = [payway];
              }
            });
            // this.payList = v.data.payWayList.slice(0, 1);
          }
          this.paywayid = this.payList[0].id; // 默认第一个
        } else {
          this.payList = v.data.payWayList;
        }
        return true;
      });

      // 执行
      this.updateStatus();
    },

    mounted() {
      preventShowBoundary('#scrollview');
    },

    destroyed() {
      clearInterval(this.rn); // 清除轮询的定时器
    },

    beforeRouteLeave(to, from, next) {
      clearInterval(this.rn); // 清除轮询的定时器
      next();
    },

    methods: {
      // 去快问页面
      goQuestion() {
        this.$router.push({path: '/question?hideNav=1'});
      },

      lookProtocol() {
        this.$store.dispatch('lookProtocol', true);
      },

      // 关闭协议
      closeProtocol() {
        this.$store.dispatch('lookProtocol', false);
      },

      // 弹起支付列表
      getPay(item, event) {
        // 如果是冒泡来的就直接 return
        if (event.target.className === 'delete icon-delete') {
          return false;
        }

        if (item.status === 0) {
          this.$store.dispatch('setLoading', true);
          window.Tracking.initTrackUrl(2, 'djk_kwys_wdfw_payType_show', '');
          // 获取价格
          this.$store.dispatch('getPriceNew').then((v) => {
            if (v.err) {
              this.$dialog.Toast({mes: v.err});
              return false;
            }
            this.price = parseFloat(v.data.price);
            return true;
          });

          // 走支付流程 获取支付列表
          this.orderCode = item.orderIdStr;
          this.interrogationId = item.id;

          this.isPay = true;
          this.$store.dispatch('setLoading', false);
          if (this.supportShubi) {
            this.$refs.payComp.handleClickShowPayBox();
          }
        } else if (item.status === 5) {
          return true;
        } else {
          this.$router.push({path: `/detail/${item.id}?hideNav=1`});
        }
        return false;
      },

      // 选择支付类型
      select(id) {
        this.paywayid = id;
        if (id === 4) {
          window.Tracking.initTrackUrl(2, 'yy_djk_kwys_wdfw_wx', '');
        } else if (id === 1) {
          window.Tracking.initTrackUrl(2, 'yy_djk_kwys_wdfw_zfb', '');
        }
      },

      // 发起支付
      pay() {
        // 点击确认支付按钮
        if (window.Tracking && typeof window.Tracking.initTrackUrl === 'function') {
          window.Tracking.initTrackUrl(2, 'yy_djk_kwys_wdfw_qrzf', '');
        }
        if (!this.paywayid) {
          this.$dialog.Toast({mes: '请选择支付方式！'});
          return false;
        }
        if (window.MT) {
          window.MT.gotoPayWithPaywayid(this.orderCode, this.paywayid);
        } else if (!Cookies.get('MT_USER_INFO')) {
          const openid = JSON.parse(Cookies.get('userInfo')).weixinUserInfo ? JSON.parse(Cookies.get('userInfo')).weixinUserInfo.openid : '';
          this.$store.dispatch('getH5ReqMsg', {
            ordercode: this.orderCode,
            paywayid: this.paywayid,
            singleWap: 1,
            wappayresultpage: 'http://m.meitun.com/inquiry/lists/?hideNav=1',
            quiturl: 'http://m.meitun.com/inquiry/lists/?hideNav=1',
            openId: openid,
            weixinappcode: 'wx5699bb5297ae3984'
          }).then((res) => {
            if (res.rtn_code === '0') {
              const data = res.data;
              let params;
              const ua = navigator.userAgent.toLowerCase();
              if (ua.indexOf('micromessenger') !== -1) {
                // 微信环境
                params = {
                  appId: data.appid,               // 公众号名称，由商户传入
                  timeStamp: data.timeStamp,       // 时间戳，自1970年以来的秒数
                  nonceStr: data.noncestr,         // 随机串
                  package: data.wxPackage,
                  signType: data.signType,         // 微信签名方式：
                  paySign: data.signedinfo,
                  returnUrl: encodeURIComponent('//m.meitun.com/inquiry/lists/?hideNav=1'),
                  backUrl: encodeURIComponent('//m.meitun.com/inquiry/lists/?hideNav=1')
                };
                location.href = `//m.meitun.com/live/info/weixin?appid=${params.appId}&timeStamp=${params.timeStamp}&noncestr=${params.nonceStr}&wxPackage=${params.package}&signType=${params.signType}&signedinfo=${params.paySign}&returnUrl=${params.returnUrl}&backUrl=${params.backUrl}`;
              } else if (this.paywayid === 4) {
                this.$dialog.Toast({mes: '非微信环境只能使用支付宝支付'});
              } else {
                params = {
                  sign: data.sign,
                  sec_id: data.secId,
                  v: data.v,
                  req_data: data.reqData,
                  service: data.service,
                  partner: data.partner,
                  format: data.format
                };
                submitForm(data.actionUrl, params);
              }
            } else {
              console.log(res.rtn_msg);
            }
          });
        }

        return true;
      },

      // 加载分页
      loadList() {
        this.currentPage += 1;

        this.$store.dispatch('getQuestionList', {
          data: {
            pagesize: this.size,
            curpage: this.currentPage
          },
          isUpdate: false
        }).then((v) => {
          if (v.err && v.err !== '用户过期，请重新登录') {
            this.$dialog.Toast({mes: v.err});
            window.$inquiry.$emit('infinitescroll.loadedDone');
            return false;
          }

          if (v.data.length < this.size) {
            // 所有数据加载完毕
            window.$inquiry.$emit('infinitescroll.loadedDone');
            return true;
          }

          this.questionLists.push(...v.data);

          // 单次请求数据完毕
          window.$inquiry.$emit('infinitescroll.finishLoad');
          return true;
        });
      },

      // 定时轮询前 20 条数据状态
      updateStatus() {
        this.rn = setInterval(() => {
          this.$store.dispatch('getQuestionList', {
            data: {
              pagesize: this.size,
              curpage: 1
            },
            isUpdate: true
          }).then((v) => {
            console.log(v);
            if (v.err && v.err !== '用户过期，请重新登录') {
              // this.$dialog.Toast({ mes: v.err });
              return false;
            } else if (v.err === '无问诊信息') {
              this.noData = true;
            }

            v.data.forEach((item, index) => {
              Vue.set(this.questionLists, index, item);
            });
            return true;
          });
        }, 12000);
      },
      paySuccess(status, msg) {
        payCallback(status);
        console.log(msg);
      }
    }
  };

  // 支付回调
  function payCallback(str) {
    if (str) {
      window.VM.$dialog.Confirm({
        mes: '支付成功！',
        opts: [
          {
            txt: '确定',
            color: true,
            callback: () => {
              ((self) => {
                self.$router.push(`/detail/${self.$data.interrogationId}?hideNav=1`);
              })(window.VM);
            }
          }
        ]
      });
    } else {
      window.VM.$dialog.Confirm({
        mes: '支付失败！',
        opts: [
          {
            txt: '确定',
            color: true,
            callback: () => {
              console.log('失败');
            }
          }
        ]
      }).call(window.VM);
      //
    }
  }

  window.payCallback = payCallback;
</script>

<style  lang="less" src="./../assets/services.less"></style>



// WEBPACK FOOTER //
// Service.vue?0e426a34